import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        navList: [], //导航数据
        userInfo: {},//用户信息
        phone: /^1(3|4|5|6|7|8|9)\d{9}$/, // 验证手机号
        email: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/, // 验证邮箱
        knowledge:{
            '初中化学':[
                require('../assets/imgs/knowledge/chuzhonghuaxue/chuzhonghuaxue.jpg'),
                require('../assets/imgs/knowledge/chuzhonghuaxue/chuzhonghuaxue2.jpg'),
                require('../assets/imgs/knowledge/chuzhonghuaxue/chuzhonghuaxue3.jpg')
            ],
            '初中数学':[
                require('../assets/imgs/knowledge/chuzhongshuxue/chuzhongshuxue.jpg'),
                require('../assets/imgs/knowledge/chuzhongshuxue/chuzhongshuxue2.jpg'),
                require('../assets/imgs/knowledge/chuzhongshuxue/chuzhongshuxue3.jpg'),
                require('../assets/imgs/knowledge/chuzhongshuxue/chuzhongshuxue4.jpg'),
                require('../assets/imgs/knowledge/chuzhongshuxue/chuzhongshuxue5.jpg'),
                require('../assets/imgs/knowledge/chuzhongshuxue/chuzhongshuxue6.jpg'),
                require('../assets/imgs/knowledge/chuzhongshuxue/chuzhongshuxue7.jpg')
            ],
            '初中物理':[
                require('../assets/imgs/knowledge/chuzhongwuli/chuzhongwuli.jpg'),
                require('../assets/imgs/knowledge/chuzhongwuli/chuzhongwuli2.jpg'),
                require('../assets/imgs/knowledge/chuzhongwuli/chuzhongwuli3.jpg')
            ],
            '初中英语':[
                require('../assets/imgs/knowledge/chuzhongyingyu/chuzhongyingyu.jpg'),
                require('../assets/imgs/knowledge/chuzhongyingyu/chuzhongyingyu2.jpg')
            ],
            '初中语文':[
                require('../assets/imgs/knowledge/chuzhongyuwen/chuzhongyuwen.jpg'),
                require('../assets/imgs/knowledge/chuzhongyuwen/chuzhongyuwen2.jpg')
            ],
            '高中地理':[
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili.jpg'),
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili2.jpg'),
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili3.jpg'),
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili4.jpg'),
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili5.jpg'),
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili6.jpg'),
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili7.jpg'),
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili8.jpg'),
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili9.jpg'),
                require('../assets/imgs/knowledge/gaozhongdili/gaozhongdili10.jpg')
            ],
            '高中化学':[
                require('../assets/imgs/knowledge/gaozhonghuaxue/gaozhonghuaxue.jpg'),
                require('../assets/imgs/knowledge/gaozhonghuaxue/gaozhonghuaxue2.jpg'),
                require('../assets/imgs/knowledge/gaozhonghuaxue/gaozhonghuaxue3.jpg'),
                require('../assets/imgs/knowledge/gaozhonghuaxue/gaozhonghuaxue4.jpg'),
                require('../assets/imgs/knowledge/gaozhonghuaxue/gaozhonghuaxue5.jpg'),
                require('../assets/imgs/knowledge/gaozhonghuaxue/gaozhonghuaxue6.jpg')
            ],
            '高中历史':[
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi2.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi3.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi4.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi5.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi6.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi7.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi8.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi9.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi10.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi11.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi12.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi13.jpg'),
                require('../assets/imgs/knowledge/gaozhonglishi/gaozhonglishi14.jpg')
            ],
            '高中生物':[
                require('../assets/imgs/knowledge/gaozhongshengwu/gaozhongshengwu.jpg'),
                require('../assets/imgs/knowledge/gaozhongshengwu/gaozhongshengwu2.jpg'),
                require('../assets/imgs/knowledge/gaozhongshengwu/gaozhongshengwu3.jpg')
            ],
            '高中数学':[
                require('../assets/imgs/knowledge/gaozhongshuxue/gaozhongshuxue.jpg'),
                require('../assets/imgs/knowledge/gaozhongshuxue/gaozhongshuxue2.jpg'),
                require('../assets/imgs/knowledge/gaozhongshuxue/gaozhongshuxue3.jpg'),
                require('../assets/imgs/knowledge/gaozhongshuxue/gaozhongshuxue4.jpg'),
                require('../assets/imgs/knowledge/gaozhongshuxue/gaozhongshuxue5.jpg'),
                require('../assets/imgs/knowledge/gaozhongshuxue/gaozhongshuxue6.jpg'),
                require('../assets/imgs/knowledge/gaozhongshuxue/gaozhongshuxue7.jpg')
            ],
            '高中物理':[
                require('../assets/imgs/knowledge/gaozhongwuli/gaozhongwuli.jpg'),
                require('../assets/imgs/knowledge/gaozhongwuli/gaozhongwuli2.jpg'),
                require('../assets/imgs/knowledge/gaozhongwuli/gaozhongwuli3.jpg'),
                require('../assets/imgs/knowledge/gaozhongwuli/gaozhongwuli4.jpg'),
                require('../assets/imgs/knowledge/gaozhongwuli/gaozhongwuli5.jpg')
            ],
            '高中英语':[
                require('../assets/imgs/knowledge/gaozhongyingyu/gaozhongyingyu.jpg'),
                require('../assets/imgs/knowledge/gaozhongyingyu/gaozhongyingyu2.jpg')
            ],
            '高中语文':[
                require('../assets/imgs/knowledge/gaozhongyuwen/gaozhongyuwen.jpg'),
                require('../assets/imgs/knowledge/gaozhongyuwen/gaozhongyuwen2.jpg')
            ],
            '高中政治':[
                require('../assets/imgs/knowledge/gaozhongzhengzhi/gaozhongzhengzhi.jpg'),
                require('../assets/imgs/knowledge/gaozhongzhengzhi/gaozhongzhengzhi2.jpg'),
                require('../assets/imgs/knowledge/gaozhongzhengzhi/gaozhongzhengzhi3.jpg'),
                require('../assets/imgs/knowledge/gaozhongzhengzhi/gaozhongzhengzhi4.jpg')
            ]
        },
        knowledge_type:{
            '初中化学':[
                require('../assets/imgs/knowledge_type/chuzhonghuaxue/chuzhonghuaxue.jpg'),
                require('../assets/imgs/knowledge_type/chuzhonghuaxue/chuzhonghuaxue2.jpg'),
                require('../assets/imgs/knowledge_type/chuzhonghuaxue/chuzhonghuaxue3.jpg')
            ],
            '初中数学':[
                require('../assets/imgs/knowledge_type/chuzhongshuxue/chuzhongshuxue.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongshuxue/chuzhongshuxue2.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongshuxue/chuzhongshuxue3.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongshuxue/chuzhongshuxue4.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongshuxue/chuzhongshuxue5.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongshuxue/chuzhongshuxue6.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongshuxue/chuzhongshuxue7.jpg')
            ],
            '初中物理':[
                require('../assets/imgs/knowledge_type/chuzhongwuli/chuzhongwuli.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongwuli/chuzhongwuli2.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongwuli/chuzhongwuli3.jpg')
            ],
            '初中英语':[
                require('../assets/imgs/knowledge_type/chuzhongyingyu/chuzhongyingyu.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongyingyu/chuzhongyingyu2.jpg')
            ],
            '初中语文':[
                require('../assets/imgs/knowledge_type/chuzhongyuwen/chuzhongyuwen.jpg'),
                require('../assets/imgs/knowledge_type/chuzhongyuwen/chuzhongyuwen2.jpg')
            ],
            '高中地理':[
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili2.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili3.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili4.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili5.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili6.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili7.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili8.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili9.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongdili/gaozhongdili10.jpg')
            ],
            '高中化学':[
                require('../assets/imgs/knowledge_type/gaozhonghuaxue/gaozhonghuaxue.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonghuaxue/gaozhonghuaxue2.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonghuaxue/gaozhonghuaxue3.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonghuaxue/gaozhonghuaxue4.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonghuaxue/gaozhonghuaxue5.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonghuaxue/gaozhonghuaxue6.jpg')
            ],
            '高中历史':[
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi2.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi3.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi4.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi5.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi6.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi7.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi8.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi9.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi10.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi11.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi12.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi13.jpg'),
                require('../assets/imgs/knowledge_type/gaozhonglishi/gaozhonglishi14.jpg')
            ],
            '高中生物':[
                require('../assets/imgs/knowledge_type/gaozhongshengwu/gaozhongshengwu.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongshengwu/gaozhongshengwu2.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongshengwu/gaozhongshengwu3.jpg')
            ],
            '高中数学':[
                require('../assets/imgs/knowledge_type/gaozhongshuxue/gaozhongshuxue.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongshuxue/gaozhongshuxue2.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongshuxue/gaozhongshuxue3.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongshuxue/gaozhongshuxue4.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongshuxue/gaozhongshuxue5.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongshuxue/gaozhongshuxue6.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongshuxue/gaozhongshuxue7.jpg')
            ],
            '高中物理':[
                require('../assets/imgs/knowledge_type/gaozhongwuli/gaozhongwuli.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongwuli/gaozhongwuli2.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongwuli/gaozhongwuli3.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongwuli/gaozhongwuli4.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongwuli/gaozhongwuli5.jpg')
            ],
            '高中英语':[
                require('../assets/imgs/knowledge_type/gaozhongyingyu/gaozhongyingyu.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongyingyu/gaozhongyingyu2.jpg')
            ],
            '高中语文':[
                require('../assets/imgs/knowledge_type/gaozhongyuwen/gaozhongyuwen.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongyuwen/gaozhongyuwen2.jpg')
            ],
            '高中政治':[
                require('../assets/imgs/knowledge_type/gaozhongzhengzhi/gaozhongzhengzhi.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongzhengzhi/gaozhongzhengzhi2.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongzhengzhi/gaozhongzhengzhi3.jpg'),
                require('../assets/imgs/knowledge_type/gaozhongzhengzhi/gaozhongzhengzhi4.jpg')
            ]
        },
    },
    mutations: {
        update(state, str) {
            state.navList = str
        },
        userInfo(state, str) {
            state.userInfo = str
        },
    },
    getters: {
        navList(state) {
            return state.navList
        },
        getUser(state) {
            return state.userInfo
        }
    }
})